<template>
  <v-content class="grey lighten-4">
    <v-toolbar flat class="blue-grey lighten-4 elevation-2">
      <v-toolbar-title>Rateios</v-toolbar-title>
    </v-toolbar>

    <v-layout row wrap>
      <v-flex xs12 class="ma-0 pa-0">
        <v-dialog @keydown.esc="fechar" max-width="500px" v-model="dialogoRateio" persistent>
          <v-btn
            title="Novo Rateio"
            color="#ff0d7b"
            dark
            slot="activator"
            class="mb-2"
            small
            absolute
            right
            fab
            style="top: 10px;"
            v-if="podeEditar"
            :disabled="idDaEmpresa == null || calculaSaldoRateio == 0"
          >
            <v-icon>add</v-icon>
          </v-btn>

          <v-toolbar>
            <span class="headline">Rateio</span>
          </v-toolbar>

          <v-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-form v-model="validacaoRateio" ref="formRateio">
                    <v-autocomplete
                      label="Selecione um Centro de Custo"
                      append-icon="business_center"
                      v-model="editandoItem.departamento"
                      :items="centrosDeCusto"
                      :loading="loadingCentrosDeCusto"
                      :rules="regraDepartamento"
                      item-text="nome"
                      item-value="id"
                      return-object
                    >
                      <template slot="no-data">
                        <div class="noDataSlot">Centro de Custo não encontrado.</div>
                      </template>
                    </v-autocomplete>

                    <v-autocomplete
                      label="Selecione a Conta Gerencial"
                      append-icon="business_center"
                      v-model="contaGerencialSelecionada"
                      :items="contasGerenciais"
                      :loading="loadingContasGerenciais"
                      item-text="nome"
                      item-value="id"
                      return-object
                      :rules="regraContaGerencial"
                    >
                      <template slot="no-data">
                        <div class="noDataSlot">Conta gerencial não encontrada.</div>
                      </template>
                    </v-autocomplete>

                    <v-text-field
                      label="Valor"
                      v-model="editandoItem.valor"
                      @blur="formataValorRateio"
                      append-icon="monetization_on"
                      validate-on-blur
                      :rules="regraValorRateio"
                    ></v-text-field>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>

            <v-card-actions style="background-color: #fff">
              <v-spacer></v-spacer>
              <v-btn color="pink" flat @click.native="fechar">Cancelar</v-btn>
              <v-btn
                color="indigo darken-4"
                flat
                @click.native="salvar"
                :disabled="!passouNasRegrasDeValidacao()"
              >Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- quando for solicitante -->
        <v-data-table
          hide-actions
          :headers="titulosTabelaDespesa"
          :items="filtraRateiosCadastrados"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.contaGerencial.nome }}</td>
            <td>{{ props.item.departamento.nome }}</td>
            <td>{{ converteMoedaReal(props.item.valor, tipoDeMoeda) }}</td>
            <td class="justify-center layout px-0">
              <v-icon small class="mr-2" @click="editar(props.item)" :disabled="!podeEditar">edit</v-icon>
              <v-icon small @click="abreDialogoDelete(props.item)" :disabled="!podeEditar">delete</v-icon>
            </td>
          </template>

          <template slot="no-data">
            <p class="text-xs-center" style="margin: 0; padding: 0">Nenhum rateio lançado.</p>
          </template>
        </v-data-table>

        <v-dialog
          @keydown.esc="dialogConfirmar = false"
          v-model="dialogConfirmar"
          max-width="500px"
        >
          <v-card style="background-color: #cc0033;">
            <v-card-title primary-title>
              <p
                class="subTitulo"
                style="color: white; margin: auto; text-align: center;"
              >Tem certeza que deseja excluir este item?</p>
            </v-card-title>
            <v-card-actions>
              <v-btn color="white" style="margin: auto; text-align: center;" @click="deletar">Sim</v-btn>
              <v-btn
                color="white"
                style="margin: auto; text-align: center;"
                @click="dialogConfirmar = false"
              >Não</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-layout row wrap class="ma-2">
        <v-flex md12 xs12 style="text-align:right">
          <span class="total">Saldo Rateio:</span>
          {{ converteMoedaReal(calculaSaldoRateio, tipoDeMoeda) }}
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <div class="text-xs-center">
          <v-btn
            class="white--text"
            color="#005ca3"
            @click="dialogoRateioAprovador = true"
            v-if="ehAprovador"
          >Ver Detalhes</v-btn>
        </div>
      </v-flex>
      <v-dialog
        @keydown.esc="dialogoRateioAprovador = false"
        v-model="dialogoRateioAprovador"
        max-width="960"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Detalhes do Rateio</span>
          </v-card-title>

          <v-data-table
            hide-actions
            :headers="titulosTabelaDespesasSemEdicao"
            :items="rateiosCadastrados"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.contaGerencial.nome }}</td>
              <td>{{ props.item.departamento.nome }}</td>
              <td>{{ converteMoedaReal(props.item.valor, tipoDeMoeda) }}</td>
              <td class="justify-center layout px-0"></td>
            </template>
          </v-data-table>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="error" @click="dialogoRateioAprovador = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-content>
</template>
<script>
import axios from "axios";
import conversor from "../../mixins/moedasMixin.js";

export default {
  data() {
    return {
      loadingContasGerenciais: false,
      contasGerenciais: null,
      validacaoRateio: false,
      dialogoRateio: false,
      dialogoRateioAprovador: false,
      dialogConfirmar: false,
      contaGerencialSelecionada: "",
      centrosDeCusto: [],
      loadingCentrosDeCusto: false,
      indexDoItemEditado: -1,
      itemAhSerRemovido: "",
      editandoItem: {
        contaGerencial: [],
        departamento: null,
        valor: ""
      },
      modeloItem: {
        contaGerencial: [],
        departamento: null,
        valor: ""
      },
      titulosTabelaDespesa: [
        { text: "Conta Gerencial" },
        { text: "Centros de Custos" },
        { text: "Valores" },
        { text: "Ações" }
      ],
      titulosTabelaDespesasSemEdicao: [
        { text: "Conta Gerencial" },
        { text: "Centros de Custos" },
        { text: "Valores" }
      ],
      regraContaGerencial: [
        contaGerencial => !!contaGerencial || "Conta Gerencial é obrigatória.",
        centroCusto =>
          this.rateiosCadastrados.filter(item => {
            if (this.indexDoItemEditado == -1) {
              if (
                item.departamento.id === this.editandoItem.departamento.id &&
                item.contaGerencial.id == this.contaGerencialSelecionada.id
              )
                return true;
              else return false;
            } else {
              for (let i = 0; i < this.rateiosCadastrados.length; i++) {
                if (i != this.indexDoItemEditado) {
                  if (
                    this.rateiosCadastrados[i].departamento.id ===
                      this.editandoItem.departamento.id &&
                    this.rateiosCadastrados[i].contaGerencial.id ==
                      this.contaGerencialSelecionada.id
                  ) {
                    return true;
                  } else return false;
                }
              }
            }
          }) == false || "Centro de custo com conta gerencial já cadastrado."
      ],
      regraDepartamento: [
        centroCusto => !!centroCusto || "Centro de Custo é obrigatório."
      ],
      regraValorRateio: [
        value => {
          let pagamentoSemVirgula;
          let valorSemVirgula;

          if (this.podeEditar) {
            pagamentoSemVirgula = conversor.methods.converterValorStringEmNumero(
              this.valorTotal,
              this.tipoDeMoeda
            );
          } else {
            if (this.valorTotal !== null) {
              pagamentoSemVirgula = conversor.methods.converterValorStringEmNumero(
                this.valorTotal,
                this.tipoDeMoeda
              );
            }
          }

          if (value !== null) {
            valorSemVirgula = conversor.methods.converterValorStringEmNumero(
              value,
              this.tipoDeMoeda
            );
          }

          if (!this.podeEditar && this.valorTotal === null) {
            return "Valor total do pedido deve ser preenchido antes de fazer o rateio. 1";
          } else if (this.podeEditar && this.valorTotal === null) {
            return "Valor total do pedido deve ser preenchido antes de atualizar o rateio. 2";
          } else if (Number(valorSemVirgula) > Number(pagamentoSemVirgula)) {
            return "Valor de rateio no centro de custo não pode ser maior ao valor total. 3";
          } else if (
            valorSemVirgula !== null &&
            !this.podeEditar &&
            !this.calcularValorTotal(this.rateiosCadastrados)
          ) {
            return `Valor de todos os rateios não pode ultrapassar o valor total do pedido. 4`;
          } else {
            if (this.indexDoItemEditado === -1) {
              //Novo item
              if (
                Number(valorSemVirgula) >
                Number(
                  conversor.methods
                    .converterValorStringEmNumero(
                      this.calculaSaldoRateio,
                      this.tipoDeMoeda
                    )
                    .toFixed(2)
                )
              )
                return `Valor de todos os rateios não pode ultrapassar o valor total do pedido. 5`;
            } else {
              let resultadoPraCalculo = 0;
              this.rateiosCadastrados.map((item, index) => {
                if (this.indexDoItemEditado != index)
                  resultadoPraCalculo += item.valor;
              });
              resultadoPraCalculo = resultadoPraCalculo + Number(value);
              if (
                resultadoPraCalculo >
                conversor.methods.converterValorStringEmNumero(
                  this.valorTotal,
                  this.tipoDeMoeda
                )
              ) {
                return `Valor de todos os rateios não pode ultrapassar o valor total do pedido. 6`;
              }
            }
            return true;
          }
        },
        valorRateio => !!valorRateio || "Valor do Rateio é obrigatório.",
        value => {
          if (
            Number(
              conversor.methods.converterValorStringEmNumero(
                value,
                this.tipoDeMoeda
              )
            ) <= 0
          )
            return `O valor do rateio não pode ser zerado.`;
        }
      ]
    };
  },
  props: {
    rateiosCadastrados: {
      type: Array,
      default: []
    },
    podeEditar: {
      type: Boolean,
      default: true
    },
    ehAprovador: {
      type: Boolean,
      default: false
    },
    tipoDeMoeda: {
      type: String,
      default: "BRL"
    },
    valorTotal: {
      type: String,
      default: ""
    },
    idDaEmpresa: {
      type: Number,
      default: 0
    }
  },
  computed: {
    centroDeCusto() {
      return this.editandoItem.departamento;
    },
    todasAsContasGerenciais() {
      return this.$store.getters.todasAsContasGerenciais;
    },
    usuarioAutenticado() {
      return this.$store.getters.usuarioAutenticado;
    },
    totalDeDespesasComVeiculo() {
      return this.$store.getters.totalDeDespesasComVeiculo;
    },
    totalDeDespesasGerais() {
      return this.$store.getters.totalDeDespesasGerais;
    },
    calculaValorTotal() {
      let gastosComVeiculo = parseFloat(this.totalDeDespesasComVeiculo);
      let gastosGerais = parseFloat(this.totalDeDespesasGerais);
      return gastosComVeiculo + gastosGerais;
    },
    calculaSaldoRateio() {
      if (this.podeEditar) {
        let valorTotalRateios = 0;
        this.rateiosCadastrados.map(rateio => {
          valorTotalRateios += parseFloat(rateio.valor);
        });
        if (this.valorTotal === null || this.valorTotal === "") {
          return "0";
        } else {
          return (
            parseFloat(
              conversor.methods.converterValorStringEmNumero(
                this.valorTotal,
                this.tipoDeMoeda
              )
            ) - valorTotalRateios
          );
        }
      } else {
        let valorPagamento = this.valorTotal;
        if (this.rateiosCadastrados.length === 0) {
          if (isNaN(valorPagamento))
            valorPagamento = conversor.methods.converterValorStringEmNumero(
              valorPagamento,
              this.tipoDeMoeda
            );

          return valorPagamento;
        }

        let valorTotalDosCentrosDeCusto = 0;
        this.rateiosCadastrados.map(centro => {
          valorTotalDosCentrosDeCusto += parseFloat(centro.valor);
        });

        if (this.valorTotal === null || this.valorTotal === "") {
          return "Valor total vazio ou incorreto";
        } else {
          return (
            parseFloat(
              conversor.methods.converterValorStringEmNumero(
                this.valorTotal,
                this.tipoDeMoeda
              )
            ) - valorTotalDosCentrosDeCusto
          );
        }
      }
    },
    filtraRateiosCadastrados() {
      if (this.ehAprovador) return [this.rateiosCadastrados[0]];
      else return this.rateiosCadastrados;
    }
  },
  methods: {
    inicializa() {
      this.$store.dispatch("get", {
        loaderName: "loadingManagementAccounts",
        service: "/contasgerenciais?size=50000",
        itemName: "todasAsContasGerenciais"
      });
    },
    converteMoedaReal(valor, tipoDeMoeda) {
      return conversor.methods.converterParaMoedaReal(valor, tipoDeMoeda);
    },
    calcularValorTotal(rateios) {
      if (rateios.length > 0) {
        let valorTotalDosCentros;
        if (this.indexDoItemEditado !== -1) {
          const centrosRelevantes = this.rateiosCadastrados.filter(
            (centro, index) => index !== this.indexDoItemEditado
          );
          valorTotalDosCentros = centrosRelevantes.reduce((acc, centro) => {
            return acc + centro.valor;
          }, 0);
        } else {
          valorTotalDosCentros = rateios.reduce((acc, centro) => {
            return acc + centro.valor;
          }, 0);
        }

        if (!this.podeEditar) {
          return valorTotalDosCentros + this.valorTotal <= this.valorTotal;
        } else {
          let valorFormatado;
          if (this.valorTotal !== null) {
            valorFormatado = this.valorTotal;
          }
          return valorTotalDosCentros + valorFormatado <= this.valorTotal;
        }
      } else {
        return true;
      }
    },
    converteValorStringEmNumero(valor) {
      if (!!valor) {
        if (typeof valor != "string") return valor;

        valor = valor
          .replace("R$", "")
          .replace("$", "")
          .replace("￥", "")
          .replace("€", "")
          .replace("£", "")
          .replace("S$", "")
          .replace("Mex$", "");
        if (this.tipoDeMoeda.indexOf("BRL") != -1) {
          valor = valor.replace(/\./g, "");
          valor = valor.replace(",", ".");
        } else if (this.tipoDeMoeda.indexOf("EUR") != -1) {
          valor = valor.replace(/\s/g, "");
          valor = valor.replace(",", ".");
        } else {
          valor = valor.replace(/\,/g, "");
        }

        if (isNaN(valor)) {
          valor = 0;
          return valor;
        }

        return valor;
      }
    },
    converteParaMoedaReal(numero) {
      let formatter;
      if (this.tipoDeMoeda == "USD")
        formatter = this.converterOutrasMoedas("en-US", "currency", "USD");
      else if (this.tipoDeMoeda == "AUD")
        formatter = this.converterOutrasMoedas("en-au", "currency", "AUD");
      else if (this.tipoDeMoeda == "CAD")
        formatter = this.converterOutrasMoedas("en-ca", "currency", "CAD");
      else if (this.tipoDeMoeda == "JPY")
        formatter = this.converterOutrasMoedas("ja", "currency", "JPY");
      else if (this.tipoDeMoeda == "EUR")
        formatter = this.converterOutrasMoedas("fr", "currency", "EUR");
      else if (this.tipoDeMoeda == "GBP")
        formatter = this.converterOutrasMoedas("en-gb", "currency", "GBP");
      else if (this.tipoDeMoeda == "SGD")
        formatter = this.converterOutrasMoedas("zh-sg", "currency", "SGD");
      else if (this.tipoDeMoeda == "MXN")
        formatter = this.converterOutrasMoedas("es-mx", "currency", "MXN");
      else formatter = this.converterOutrasMoedas("pt-BR", "currency", "BRL");
      return formatter.format(numero);
    },

    converterOutrasMoedas(linguagem, estilo, pais) {
      return new Intl.NumberFormat(linguagem, {
        style: estilo,
        currency: pais,
        minimumFractionDigits: 2
      });
    },
    formataValorRateio(eventoBlur) {
      const formataValor = conversor.methods.converterValorStringEmNumero(
        eventoBlur.target.value,
        this.tipoDeMoeda
      );
      this.editandoItem.valor = conversor.methods.converterParaMoedaReal(
        formataValor,
        this.tipoDeMoeda
      );
    },
    salvar() {
      let numero = conversor.methods.converterValorStringEmNumero(
        this.editandoItem.valor,
        this.tipoDeMoeda
      );
      this.editandoItem.valor = parseFloat(numero);

      this.editandoItem.contaGerencial = this.contaGerencialSelecionada;

      if (this.indexDoItemEditado > -1)
        Object.assign(
          this.rateiosCadastrados[this.indexDoItemEditado],
          this.editandoItem
        );
      else this.rateiosCadastrados.push(this.editandoItem);
      this.$emit("rateios", this.rateiosCadastrados);
      this.fechar();
    },
    editar(item) {
      this.indexDoItemEditado = this.rateiosCadastrados.indexOf(item);
      this.editandoItem = Object.assign({}, item);
      let numero = conversor.methods.converterParaMoedaReal(
        item.valor,
        this.tipoDeMoeda
      );
      this.editandoItem.valor = numero;
      this.contaGerencialSelecionada = this.editandoItem.contaGerencial;
      this.dialogoRateio = true;
    },
    deletar() {
      const index = this.rateiosCadastrados.indexOf(this.itemAhSerRemovido);
      this.rateiosCadastrados.splice(index, 1);
      this.dialogConfirmar = false;
      this.itemAhSerRemovido = "";
      this.contaGerencialSelecionada = "";
    },
    fechar() {
      this.dialogoRateio = false;
      this.editandoItem = Object.assign({}, this.modeloItem);
      this.contaGerencialSelecionada = "";
      this.indexDoItemEditado = -1;
    },
    abreDialogoDelete(item) {
      this.itemAhSerRemovido = item;
      this.dialogConfirmar = true;
    },
    passouNasRegrasDeValidacao() {
      if (this.validacaoRateio) return true;
      else return false;
    },
    async fazerRequest(url) {
      return await axios({
        method: "get",
        url: url,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioAutenticado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(resposta => {
          return resposta.data;
        })
        .catch(erro => {});
    }
  },
  watch: {
    async centroDeCusto(conta) {
      this.loadingContasGerenciais = true;
      await this.fazerRequest(`/contasgerenciais/centrodecustos/${conta.id}`)
        .then(s => {
          this.contasGerenciais = s;
        })
        .catch(s => (this.centrosDeCusto = []))
        .finally(s => (this.loadingContasGerenciais = false));
    },
    async idDaEmpresa(val) {
      if (val == 0) return;
      this.contasGerenciais = [];
      this.loadingCentrosDeCusto = true;
      await this.fazerRequest(`/centrosdecustos/empresas/${val}`)
        .then(s => {
          this.centrosDeCusto = s;
        })
        .catch(s => (this.contasGerenciais = []))
        .finally(s => (this.loadingCentrosDeCusto = false));
    }
  },
  created() {
    this.inicializa();
  }
};
</script>
<style>
.total {
  color: #005ca3;
  font-weight: bold;
}
.noDataSlot {
  font-size: 1em;
  padding: 10px;
}
</style>